/// <amd-module name="SuiteCommerce.ProductLeadTime.PDP"/>
define("SuiteCommerce.ProductLeadTime.PDP", ["require", "exports", "SuiteCommerce.ProductLeadTime.PDP.View", "SuiteCommerce.ProductLeadTime.PDP.Model"], function (require, exports, PDP_View_1, PDP_Model_1) {
    "use strict";
    return {
        mountToApp: function (container) {
            var pdp = container.getComponent('PDP');
            if (pdp) {
                var pdpView_1;
                pdp.addChildView('Product.Stock.Info', function () {
                    pdpView_1 = new PDP_View_1.PDPView({ pdp: pdp, model: new PDP_Model_1.PDPModel() });
                    return pdpView_1;
                });
                pdp.on('afterOptionSelection', function () {
                    if (pdpView_1) {
                        pdpView_1.selectItem();
                    }
                });
            }
        },
    };
});
